/**
 * The Intl locale for a UI language. Arabic uses the Jordan locale, as the
 * apps do (`intlLocale` in @linkhr/i18n, which the design system may not
 * import), with Latin digits when the user chose them. The numerals mode is
 * read off the globalThis channel `packages/i18n/src/numerals.ts` publishes,
 * like the date primitives do (`CalendarDate.tsx`); keep the key identical.
 */
export function uiLocale(language: string | undefined): string | undefined {
  if (language !== "ar" && language?.startsWith("ar-") !== true) return language;
  const latin = (globalThis as Record<string, unknown>)["__linkhrNumeralsMode__"] === "latin";
  return latin ? "ar-JO-u-nu-latn" : "ar-JO";
}

/**
 * A count in the UI language's digits; a string is an app-formatted count
 * (e.g. honouring a Latin-digits preference) and passes through unchanged.
 */
export function formatCount(count: number | string, language: string | undefined): string {
  if (typeof count === "string") return count;
  return new Intl.NumberFormat(uiLocale(language)).format(count);
}
